export const AccountRoutePaths = {
  base: "/account",
  signIn: "/account/sign-in",
  signUp: "/account/sign-up",
  forgotPassword: "/account/forgot-password",
  resetPassword: "/account/reset-password",
  confirmRegistration: "/account/confirm-registration",
  confirmInviteRegistration: "/account/confirm-invite-registration",
} as const;

export const buildAccountSignInWithReturn = (returnUrl: string): string => {
  return `${AccountRoutePaths.signIn}?returnUrl=${encodeURIComponent(returnUrl)}`;
};

/** sessionStorage key for preserving the partner invite token through the email confirmation step */
export const PARTNER_INVITE_STORAGE_KEY = "partnerInviteToken";